import React, { useState, useEffect, useContext } from "react";
import { useRecoilValue } from "recoil";

import Modal from "components/modal";
import LineLoader from "components/lineLoader";
import Input from "components/input";
import Button from "components/button";
import useOverlay from "hooks/useOverlay";
import { BASE_ASSETS_URL } from "constants/app";
import { trackAnalytics } from "services/analytics";
import Service from "../service";
import useClickToCall from "../useClickToCall";
import { validateContactNumber } from "../validations";
import { CONTACT_NUMBER_VALIDATION, clickToCallAtom } from "../constants";

import styles from "./updateBeforeCallView.scss";

export default function UpdateBeforeCallView({ profile, setProfile, lob, callBinded }) {
  const state = useRecoilValue(clickToCallAtom);
  const { dismiss, updateCallPayload } = useClickToCall();

  const [contactNumber, setContactNumber] = useState(() => ({
    touched: false,
    errors: [],
    value: profile.personalInfo.communicationNumber,
  }));
  const [isEditable, setIsEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useOverlay(true);

  const update = () => {
    setIsLoading(true);
    const {
      personalInfo: { userName, emailId, communicationNumberPrefix },
    } = profile;
    const payload = {
      emailId,
      communicationNumber: contactNumber.value,
      communicationNumberPrefix: communicationNumberPrefix || "91",
      userName,
      operationSet: ["communicationNumber", "communicationNumberPrefix", "userName"],
    };
    Service.updateProfile({ payload, headers: { lob }})
      .then(() => {
        setProfile({ personalInfo: { ...profile.personalInfo, communicationNumber: contactNumber.value } });
        updateCallPayload({ userNumber: contactNumber.value });
        setIsEditable(false);
      })
      .finally(() => setIsLoading(false));
  };

  const faOnClickToCall = (type) => {
    trackAnalytics({
      eVar9: `b2b|selfcare|${lob.toLowerCase()}|contact|${type}`,
      eVar8: `b2b|selfcare|${lob.toLowerCase()}`,
    });
  };

  const handleCall = () => {
    faOnClickToCall(state.agentContactType);
    callBinded();
  }

  const handleContactNumberChange = (value) => {
    if (CONTACT_NUMBER_VALIDATION.test(value) && value.length <= 10) {
      setContactNumber({
        touched: true,
        value,
        errors: validateContactNumber(value),
      });
    }
  }

  const body = (
      <div className={styles.click_to_call_update_view}>
        <span className={styles.close_modal} onClick={dismiss}></span>

        <h5 className={styles.modal_title}>Dear {profile.personalInfo.userName},</h5>
        <p className={styles.modal_message}>Please check your contact details before placing a call</p>
        {isEditable && (
          <>
            <div className={styles.contact_input}>
              <span className={styles.country_code}>+91</span>
              <Input
                placeholder=""
                label="Contact Number"
                required
                value={contactNumber.value}
                errors={contactNumber.errors}
                touched={contactNumber.touched}
                onBlur={() =>
                  setContactNumber({
                    ...contactNumber,
                    touched: true,
                    errors: validateContactNumber(contactNumber.value),
                  })
                }
                onChange={handleContactNumberChange}
              />
            </div>
            <Button disabled={contactNumber.errors.length} onClick={update}>
              Update
            </Button>
          </>
        )}
        {!isEditable && (
          <div className={styles.editable_area}>
            <div className={styles.edit_lable}>Contact Number</div>
            <div className={styles.editable_field}>
              <div className={styles.editable_text}><span className={styles.country_code}>+91{" "}</span>{contactNumber.value}</div>
              <span className={styles.edit_icon} onClick={() => setIsEditable(true)}>
                <img src={`${BASE_ASSETS_URL}/images/edit-icon.svg`} />
              </span>
            </div>
            <div className={styles.button_area}>
              <Button onClick={handleCall}>Call</Button>
            </div>
          </div>
        )}
      </div>
  );

  return (
    <>
      <LineLoader show={isLoading} />
      <Modal body={body} onCloseClick={dismiss} />
    </>
  );
}
